import React from 'react';
import { MedicalProtocolsState, MedicalProtocolsUnloadState } from '../states/MedicalProtocolsState';

// MedicalProtocols Reducer
import { Action, Reducer } from 'redux';

// actions
import * as Actions from '../actions/';

// functions
import * as Functions from '../../functions/common';
import { Protocol } from '../../models/Entities/Protocols/Protocol';
import { ProtocolConsumption } from '../../models/Entities/Protocols/ProtocolConsumption';
import { ProtocolConsumptionConceptValues } from '../../models/Entities/Protocols/ProtocolConsumptionConceptValues';
import { ProtocolConsumptionSyncProcessLog } from '../../models/Entities/Protocols/ProtocolConsumptionSyncProcessLog';
import { ProtocolConsumptionTotal } from '../../models/Entities/Protocols/ProtocolConsumptionTotal';
import { ContractStage } from '../../models/Entities/Contracts/ContractStage';
import { ProtocolConsumptionVisit } from '../../models/Entities/Protocols/ProtocolConsumptionVisit';
import { ProtocolPatient } from '../../models/Entities/Protocols/ProtocolPatient';
import { ProtocolPatientContractBranch } from '../../models/Entities/Protocols/ProtocolPatientContractBranch';


type KnownAction = 
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Request_Action 
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Receive_Action 
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Fail_Action
| Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Fail_Action
| Actions.MedicalProtocols.MedicalProtocols_GetById_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetById_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetById_Fail_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Fail_Action
| Actions.Contract.Contract_Associate_To_Protocol_Receive_Action
| Actions.Contract.Contract_Disassociate_From_Protocol_Receive_Action
| Actions.ProtocolPractitioners.ProtocolPractitiones_GetAll_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ProtocolPatients_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ProtocolPatients_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ProtocolPatients_Fail_Action
| Actions.MedicalProtocols.MedicalProtocolsGetAllProtocolPatientContractBranchesReceiveAction
| Actions.MedicalProtocols.MedicalProtocolsSetProtocolPatientContractBranchReceiveAction
| Actions.MedicalProtocols.MedicalProtocolsDeleteProtocolPatientContractBranchReceiveAction
| Actions.ProtocolPractitioners.ProtocolPractitionesStudyTask_GetAll_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_PatientVisit_ByProtocolId_Receive_Action

// visits
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Fail_Action

// visits full
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Fail_Action

// PDF and Excel export actions
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfRequestAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfReceiveAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfFailAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelRequestAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelReceiveAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelFailAction

// protocol consumption actions
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionCreateRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionCreateSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionCreateFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionUpdateRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionUpdateSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionUpdateFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionDeleteRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionDeleteSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionDeleteFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusFailureAction
| Actions.ProtocolConsumptions.MarkConsumptionFollowUpRequestAction
| Actions.ProtocolConsumptions.MarkConsumptionFollowUpSuccessAction
| Actions.ProtocolConsumptions.MarkConsumptionFollowUpFailAction

// protocol consumption to settle actions
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleFailureAction

// protocol consumption sync process actions
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetAllByProtocolIdRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetAllByProtocolIdSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetAllByProtocolIdFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetByIdRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetByIdSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetByIdFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLogsByIdRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLogsByIdSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLogsByIdFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLastByProtocolIdRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLastByProtocolIdSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLastByProtocolIdFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessCreateRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessCreateSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessCreateFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessUpdateRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessUpdateSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessUpdateFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessDeleteRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessDeleteSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessDeleteFailureAction

// protocol consumption concept values (CRUD)
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueGetAllRequestAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueGetAllSuccessAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueGetAllFailureAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueCreateRequestAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueCreateSuccessAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueCreateFailureAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueUpdateRequestAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueUpdateSuccessAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueUpdateFailureAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueDeleteRequestAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueDeleteSuccessAction
| Actions.ProtocolConsumptionConceptValues.ProtocolConsumptionConceptValueDeleteFailureAction

// early discontinuation y agrupación manual del consumo
| Actions.ProtocolConsumptions.ProtocolConsumptionSetEarlyDiscontinuationRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetEarlyDiscontinuationSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetEarlyDiscontinuationFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetGroupingRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetGroupingSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetGroupingFailureAction

// protocols consumption Totals
| Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusFailureAction

// protocol consumption change concept actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptFailureAction

// protocol consumption change producer actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerFailureAction

// protocol consumption change provider actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderFailureAction

// visit link
| Actions.ContractStages.ContractStage_LinkToAProtocolVisit_Request_Action
| Actions.ContractStages.ContractStage_LinkToAProtocolVisit_Receive_Action
| Actions.ContractStages.ContractStage_LinkToAProtocolVisit_Fail_Action

// protocol consumption change amount actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountFailureAction

// protocol consumption change medical service actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceFailureAction

// protocol consumption change visit type actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeFailureAction

// protocol consumption change visit (stage) actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitFailureAction
// set as procedure/additional
| Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalFailureAction
// get consumptions by patient
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByPatientRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByPatientSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByPatientFailureAction

// get consumptions billed in the contract concept
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllBilledInConceptRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllBilledInConceptSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllBilledInConceptFailureAction;

const isContractBranchActiveOn = (
    branch: ProtocolPatientContractBranch,
    referenceDate: Date
): boolean => {
    const from = branch.dateFrom ? new Date(branch.dateFrom) : undefined;
    const to = branch.dateTo ? new Date(branch.dateTo) : undefined;

    if (from && from.getTime() > referenceDate.getTime()) {
        return false;
    }

    if (to && to.getTime() < referenceDate.getTime()) {
        return false;
    }

    return true;
};

// A patient can have several contract-branch associations over different date ranges.
// The "current" one is the one whose [dateFrom, dateTo] range covers today; if none is
// currently active, fall back to the most recently STARTED assignment (never a future one).
const pickCurrentContractBranch = (
    branches: ProtocolPatientContractBranch[]
): ProtocolPatientContractBranch | undefined => {
    if (branches.length === 0) {
        return undefined;
    }

    const now = new Date();
    const startedBranches = branches.filter(
        (branch) => !branch.dateFrom || new Date(branch.dateFrom).getTime() <= now.getTime()
    );

    if (startedBranches.length === 0) {
        return undefined;
    }

    const activeBranches = startedBranches.filter((branch) => isContractBranchActiveOn(branch, now));
    const candidates = activeBranches.length > 0 ? activeBranches : startedBranches;

    return [...candidates].sort((a: ProtocolPatientContractBranch, b: ProtocolPatientContractBranch) => {
        const aTime = a.dateFrom ? new Date(a.dateFrom).getTime() : 0;
        const bTime = b.dateFrom ? new Date(b.dateFrom).getTime() : 0;
        return bTime - aTime;
    })[0];
};

const mapPatientsWithContractBranches = (
    patients: ProtocolPatient[] | undefined,
    branches: ProtocolPatientContractBranch[] | undefined
): ProtocolPatient[] | undefined => {
    if (!patients) {
        return patients;
    }

    return patients.map((patient: ProtocolPatient) => {
        const patientBranches = (branches || []).filter(
            (branch: ProtocolPatientContractBranch) =>
                branch.numberInProtocol.toLowerCase() === patient.numberInProtocol.toLowerCase()
        );

        const match = pickCurrentContractBranch(patientBranches);

        if (!match) {
            return {
                ...patient,
                protocolPatientContractBranchId: undefined,
                contractBranchId: undefined,
                contractBranchName: undefined
            };
        }

        return {
            ...patient,
            protocolPatientContractBranchId: match.id,
            contractBranchId: match.contractBranchId,
            contractBranchName: match.contractBranchName
        };
    });
};

 



// El detalle de un consumo se puede abrir tanto para un consumo de primer
// nivel como para uno anidado en el childConsumption de su padre (asi lo
// resuelve ConsumptionDetails). Las banderas y el billedIn tienen que
// escribirse en el mismo lugar del que despues los lee el componente.
const UpdateConsumptionById = (
    consumptions: ProtocolConsumption[] | undefined,
    consumptionId: string,
    updater: (consumption: ProtocolConsumption) => ProtocolConsumption
): ProtocolConsumption[] =>
    (consumptions || []).map((cons: ProtocolConsumption) => {
        if (cons.id === consumptionId) return updater(cons);

        if ((cons.childConsumption || []).some((child: ProtocolConsumption) => child.id === consumptionId)) {
            return {
                ...cons,
                childConsumption: (cons.childConsumption || []).map((child: ProtocolConsumption) =>
                    child.id === consumptionId ? updater(child) : child
                )
            };
        }

        return cons;
    });

/**
 * Aplica `updater` al consumo indicado y devuelve el state completo ya
 * reensamblado. Es el mismo bloque de tres pasos (buscar protocolo, mapear el
 * consumo, reemplazar el protocolo en la lista) que repiten los casos previos,
 * extraido para que los del CRUD de conceptos adicionales quepan en una linea.
 */
const WriteConsumption = (
    state: MedicalProtocolsState,
    protocolId: number,
    consumptionId: string,
    updater: (consumption: ProtocolConsumption) => ProtocolConsumption
): MedicalProtocolsState => {
    const currentProtocol: Protocol | undefined = state.list?.find((item: Protocol) => item.id === protocolId);

    if (!currentProtocol) {
        return state;
    }

    const updatedProtocol: Protocol = {
        ...currentProtocol,
        consumptions: UpdateConsumptionById(currentProtocol.consumptions, consumptionId, updater)
    };

    return {
        ...state,
        list: [...(state.list ?? []).filter((item: Protocol) => item.id !== protocolId), updatedProtocol]
    };
};

export const MedicalProtocolsReducer: Reducer<MedicalProtocolsState> = (
    state: MedicalProtocolsState | undefined, incomingAction: Action): MedicalProtocolsState => {
    
    if (state === undefined) {
        return MedicalProtocolsUnloadState as MedicalProtocolsState;
    }

    const action = incomingAction as KnownAction;

    let CurrentProtocol: Protocol | undefined = undefined;

    switch (action.type) {
        case 'MEDICALPROTOCOLS_GET_ALL_REQUEST_ACTION':
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GET_ALL_RECEIVE_ACTION':
            // Merge new protocols with existing ones, preserving additional properties
            const mergedList = action.MedicalProtocols.map((newProtocol: Protocol) => {
                // Find existing protocol with same ID
                const existingProtocol = state.list?.find((p: Protocol) => p.id === newProtocol.id);
                
                if (existingProtocol) {
                    // Merge: keep additional properties from existing, update base properties from new
                    return {
                        ...newProtocol,                          // Base properties from server
                        patients: existingProtocol.patients,     // Preserve loaded patients
                        contractAssociation: existingProtocol.contractAssociation, // Preserve contract association
                        practitioners: existingProtocol.practitioners, // Preserve practitioners
                        practitionersStudyRole: existingProtocol.practitionersStudyRole, // Preserve study role practitioners
                        patientVisits: existingProtocol.patientVisits, // Preserve patient visits
                        consumptions: existingProtocol.consumptions, // Preserve consumptions
                    };
                } else {
                    // New protocol, just add it
                    return newProtocol;
                }
            });
            
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: mergedList.sort(Functions.DynamicSort('title'))
            };
        case 'MEDICALPROTOCOLS_GET_ALL_FAIL_ACTION':
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };
        case 'MEDICALPROTOCOLS_UPDATE_ALL_REQUEST_ACTION':
            return {
                ...state,
                isUpdatingAll: true,
                isUpdatingAllSuccess: undefined,
                FailUpdatingAll: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_UPDATE_ALL_RECEIVE_ACTION':
            // Merge updated protocols with existing ones, preserving additional properties
            const mergedUpdateList = action.MedicalProtocols.map((updatedProtocol: Protocol) => {
                // Find existing protocol with same ID
                const existingProtocol = state.list?.find((p: Protocol) => p.id === updatedProtocol.id);
                
                if (existingProtocol) {
                    // Merge: keep additional properties from existing, update base properties from new
                    return {
                        ...updatedProtocol,                          // Base properties from server
                        patients: existingProtocol.patients,     // Preserve loaded patients
                        contractAssociation: existingProtocol.contractAssociation, // Preserve contract association
                        practitioners: existingProtocol.practitioners, // Preserve practitioners
                        practitionersStudyRole: existingProtocol.practitionersStudyRole, // Preserve study role practitioners
                        patientVisits: existingProtocol.patientVisits, // Preserve patient visits
                        consumptions: existingProtocol.consumptions, // Preserve consumptions
                    };
                } else {
                    // New protocol, just add it
                    return updatedProtocol;
                }
            });
            
            return {
                ...state,
                isUpdatingAll: false,
                isUpdatingAllSuccess: true,
                FailUpdatingAll: false,
                error: undefined,
                list: mergedUpdateList
            };
        case 'MEDICALPROTOCOLS_UPDATE_ALL_FAIL_ACTION':
            return {
                ...state,
                isUpdatingAll: false,
                isUpdatingAllSuccess: false,
                FailUpdatingAll: true,
                error: action.error
            };
        case 'MEDICALPROTOCOLS_GET_BY_ID_REQUEST_ACTION':
            return {
                ...state,
                isLoadingOne: true,
                successLoadingOne: false,
                failOnLoadingOne: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GET_BY_ID_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.MedicalProtocol.id);
            var UpdatedProtocol = action.MedicalProtocol;

            if(CurrentProtocol) {
                UpdatedProtocol = {...UpdatedProtocol, 
                    contractAssociation: CurrentProtocol.contractAssociation, 
                    practitioners: CurrentProtocol.practitioners, 
                    patients: CurrentProtocol.patients, 
                    visits: CurrentProtocol.visits, 
                    patientVisits: CurrentProtocol.patientVisits,
                    ContractVisits: CurrentProtocol.ContractVisits,
                    consumptions: CurrentProtocol.consumptions, 
                    consumptionsSyncProcess: CurrentProtocol.consumptionsSyncProcess, 
                    lastConsumptionSyncProcess: CurrentProtocol.lastConsumptionSyncProcess, 
                    AmountTotals: CurrentProtocol.AmountTotals
                };
            }

            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                error: undefined,
                list: (state.list ? [...state.list?.filter((item: any) => item.id !== UpdatedProtocol.id), UpdatedProtocol]: [UpdatedProtocol])
            };
        case 'MEDICALPROTOCOLS_GET_BY_ID_FAIL_ACTION':
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: action.error
            };
        case 'CONTRACT_ASSOCIATE_TO_PROTOCOL_RECEIVE_ACTION':
            var ProtocolWithContractAssociated = state.list?.find((item: Protocol) => item.id === action.contractProtocolAssociation.protocolId);
            if(ProtocolWithContractAssociated) {
                ProtocolWithContractAssociated = {...ProtocolWithContractAssociated, contractAssociation : action.contractProtocolAssociation};
            }
            return {
                ...state,
                list: ProtocolWithContractAssociated
                    ? [...(state.list || []).filter((item: any) => item.id !== action.contractProtocolAssociation.protocolId), ProtocolWithContractAssociated].sort(Functions.DynamicSort('title'))
                    : state.list
            };
        case 'CONTRACT_DISASSOCIATE_FROM_PROTOCOL_RECEIVE_ACTION':
            var ProtocolWithContractDisassociated = state.list?.find((item: Protocol) => item.id === action.ProtocolId);
            if(ProtocolWithContractDisassociated) {
                ProtocolWithContractDisassociated = {...ProtocolWithContractDisassociated, contractAssociation : undefined};
            }
            return {
                ...state,
                list: ProtocolWithContractDisassociated
                    ? [...(state.list || []).filter((item: any) => item.id !== action.ProtocolId), ProtocolWithContractDisassociated].sort(Functions.DynamicSort('title'))
                    : state.list
            };
        case 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_REQUEST_ACTION':
            return {
                ...state,
                isGettingProtocolContractAssociation: true,
                isGettingProtocolContractAssociationSuccess: undefined,
                FailGettingProtocolContractAssociation: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_RECEIVE_ACTION':
            const updatedListWithContract = state.list?.map((protocol: Protocol) => {
                if(protocol.id === action.ProtocolId) {
                    // Spread operator preserves all properties including patients
                    return {...protocol, contractAssociation: action.contractAssociation};
                } else {
                    return protocol;
                }
            });
            
            return {
                ...state,
                isGettingProtocolContractAssociation: false,
                isGettingProtocolContractAssociationSuccess: true,
                FailGettingProtocolContractAssociation: false,
                list: updatedListWithContract,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_FAIL_ACTION':
            return {
                ...state,
                isGettingProtocolContractAssociation: false,
                isGettingProtocolContractAssociationSuccess: false,
                FailGettingProtocolContractAssociation: true,
                error: action.error
            };
        case 'PROTOCOL_PRACTITIONERS_GETALL_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if(protocol.id === action.protocolId) {
                        return {...protocol, practitioners : action.protocolPractitioners};
                    } else {
                        return protocol;
                    }
                })
            };
        case 'PROTOCOL_PRACTITIONERS_STUDYTASK_GETALL_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if(protocol.id === action.protocolId) {
                        return {...protocol, practitionersStudyTask : action.protocolPractitioners};
                    } else {
                        return protocol;
                    }
                })
            };
        // Sin esta bandera la pantalla por paciente no puede distinguir "todavía
        // no llegaron" de "este protocolo no tiene", y mostraba el vacío en ambos.
        case 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_REQUEST_ACTION':
            return { ...state, isLoadingProtocolPatients: true };

        case 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_FAIL_ACTION':
            return { ...state, isLoadingProtocolPatients: false };

        case 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_RECEIVE_ACTION':
            // Handle case where list might be undefined
            if (!state.list) {
                return { ...state, isLoadingProtocolPatients: false };
            }
            
            const updatedList = state.list.map((protocol: Protocol) => {
                if(protocol.id === action.ProtocolId) {
                    return {
                        ...protocol,
                        patients: mapPatientsWithContractBranches(action.ProtocolPatients, protocol.patientContractBranches)
                    };
                } else {
                    return protocol;
                }
            });
            
            return {
                ...state,
                isLoadingProtocolPatients: false,
                list: updatedList
            };
        case 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENT_CONTRACTBRANCHES_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if (protocol.id === action.ProtocolId) {
                        const mergedBranches = action.ProtocolPatientContractBranches;

                        return {
                            ...protocol,
                            patientContractBranches: mergedBranches,
                            patients: mapPatientsWithContractBranches(protocol.patients, mergedBranches)
                        };
                    }

                    return protocol;
                })
            };
        case 'MEDICALPROTOCOLS_SET_PROTOCOLPATIENT_CONTRACTBRANCH_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if (protocol.id === action.ProtocolId) {
                        const currentBranches = protocol.patientContractBranches || [];
                        const nextBranches = [
                            ...currentBranches.filter(
                                (item: ProtocolPatientContractBranch) =>
                                    item.id !== action.ProtocolPatientContractBranch.id
                            ),
                            action.ProtocolPatientContractBranch
                        ];

                        return {
                            ...protocol,
                            patientContractBranches: nextBranches,
                            patients: mapPatientsWithContractBranches(protocol.patients, nextBranches)
                        };
                    }

                    return protocol;
                })
            };
        case 'MEDICALPROTOCOLS_DELETE_PROTOCOLPATIENT_CONTRACTBRANCH_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if (protocol.id === action.ProtocolId) {
                        const nextBranches = (protocol.patientContractBranches || []).filter(
                            (item: ProtocolPatientContractBranch) => item.id !== action.Id
                        );

                        return {
                            ...protocol,
                            patientContractBranches: nextBranches,
                            patients: mapPatientsWithContractBranches(protocol.patients, nextBranches)
                        };
                    }

                    return protocol;
                })
            };
        case 'MEDICALPROTOCOLS_GETALL_PATIENTVISIT_BYPROTOCOLID_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if(protocol.id === action.ProtocolId) {
                        return {...protocol, patientVisits : action.visits};
                    } else {
                        return protocol;
                    }
                })
            };
        case 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_REQUEST_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: true, gettingVisitsSuccess: undefined, failOnGettingVisits: false, ErrorOnGettingVisits: undefined};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            }

        case 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: true, failOnGettingVisits: false, ErrorOnGettingVisits: undefined, visits: action.visits};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        case 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_FAIL_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: false, failOnGettingVisits: true, ErrorOnGettingVisits: action.error};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        // visit full 
        case 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_REQUEST_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: true, gettingVisitsSuccess: undefined, failOnGettingVisits: false, ErrorOnGettingVisits: undefined};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        case 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: true, failOnGettingVisits: false, ErrorOnGettingVisits: undefined, ContractVisits: action.visits};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        case 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_FAIL_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: false, failOnGettingVisits: true, ErrorOnGettingVisits: action.error};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };
        
        // protocol consumption actions
        case 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingConsumptions: true, gettingConsumptionsSuccess: undefined, failOnGettingConsumptions: false, ErrorOnGettingConsumptions: undefined};
            }

            console.log('CurrentProtocol', CurrentProtocol);

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list),
            };
        case 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if (CurrentProtocol) {
                const hasGroupFilter = !!(action.filters?.GroupId);

                if (hasGroupFilter) {
                    const groupId = action.filters?.GroupId;
                    const updatedConsumptions = (CurrentProtocol.consumptions || []).map((cons: ProtocolConsumption) => {
                        if (cons.groupingId === groupId) {
                            return { ...cons, childConsumption: action.consumptions };
                        }
                        return cons;
                    });

                    CurrentProtocol = {
                        ...CurrentProtocol,
                        consumptions: updatedConsumptions,
                        consumptionPagintationState: action.paginationState,
                        consumptionsFilters: action.filters ?? CurrentProtocol.consumptionsFilters,
                        isGettingConsumptions: false,
                        gettingConsumptionsSuccess: true,
                        failOnGettingConsumptions: false,
                        ErrorOnGettingConsumptions: undefined,
                    };
                } else {
                    CurrentProtocol = {
                        ...CurrentProtocol,
                        consumptions: action.consumptions,
                        consumptionPagintationState: action.paginationState,
                        consumptionsFilters: action.filters ?? CurrentProtocol.consumptionsFilters,
                        isGettingConsumptions: false,
                        gettingConsumptionsSuccess: true,
                        failOnGettingConsumptions: false,
                        ErrorOnGettingConsumptions: undefined,
                    };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };
        case 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_FAILURE':
            return {
                ...state,
                isLoadingAllConsumptions: false,
                LoadingAllConsumptionsSuccess: false,
                FailGettingAllConsumptions: true,
                ErrorGettingAllConsumptions: action.error
            };

        case 'PROTOCOLCONSUMPTION_GETALL_BYPATIENT_REQUEST':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol = {
                    ...CurrentProtocol,
                    patientConsumptionsLoading: {
                        ...(CurrentProtocol.patientConsumptionsLoading ?? {}),
                        [action.numberInProtocol]: true
                    }
                };
            }
            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_GETALL_BYPATIENT_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol = {
                    ...CurrentProtocol,
                    consumptionsByPatient: {
                        ...(CurrentProtocol.consumptionsByPatient ?? {}),
                        [action.numberInProtocol]: action.consumptions
                    },
                    patientConsumptionsLoading: {
                        ...(CurrentProtocol.patientConsumptionsLoading ?? {}),
                        [action.numberInProtocol]: false
                    }
                };
            }
            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_GETALL_BYPATIENT_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol = {
                    ...CurrentProtocol,
                    patientConsumptionsLoading: {
                        ...(CurrentProtocol.patientConsumptionsLoading ?? {}),
                        [action.numberInProtocol]: false
                    }
                };
            }
            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        // Los consumos facturados dentro del concepto se guardan en la propiedad
        // billedIn del consumo consultado, junto con sus banderas de carga.
        case 'PROTOCOLCONSUMPTION_GETALL_BILLEDINCONCEPT_REQUEST':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol = {
                    ...CurrentProtocol,
                    consumptions: UpdateConsumptionById(CurrentProtocol.consumptions, action.consumptionId, (cons: ProtocolConsumption) => ({
                        ...cons,
                        isGettingBilledInConcepts: true,
                        gettingBilledInConceptsSuccess: undefined,
                        failOnGettingBilledInConcepts: false,
                        ErrorOnGettingBilledInConcepts: undefined
                    }))
                };
            }
            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_GETALL_BILLEDINCONCEPT_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol = {
                    ...CurrentProtocol,
                    consumptions: UpdateConsumptionById(CurrentProtocol.consumptions, action.consumptionId, (cons: ProtocolConsumption) => ({
                        ...cons,
                        billedIn: action.consumptions,
                        isGettingBilledInConcepts: false,
                        gettingBilledInConceptsSuccess: true,
                        failOnGettingBilledInConcepts: false,
                        ErrorOnGettingBilledInConcepts: undefined
                    }))
                };
            }
            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_GETALL_BILLEDINCONCEPT_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol = {
                    ...CurrentProtocol,
                    consumptions: UpdateConsumptionById(CurrentProtocol.consumptions, action.consumptionId, (cons: ProtocolConsumption) => ({
                        ...cons,
                        isGettingBilledInConcepts: false,
                        gettingBilledInConceptsSuccess: false,
                        failOnGettingBilledInConcepts: true,
                        ErrorOnGettingBilledInConcepts: action.error
                    }))
                };
            }
            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        // ─── Concept values (conceptos adicionales) ──────────────────────────
        // Viven dentro del consumo, asi que se escriben con el mismo helper que
        // el resto de las banderas por consumo: el detalle puede estar mirando
        // un consumo de primer nivel o uno anidado en childConsumption.

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_GETALL_REQUEST':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isLoadingConceptValues: true,
                loadingConceptValuesSuccess: undefined,
                failOnLoadingConceptValues: false,
                ErrorOnLoadingConceptValues: undefined
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_GETALL_SUCCESS':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                conceptValues: action.conceptValues,
                isLoadingConceptValues: false,
                loadingConceptValuesSuccess: true,
                failOnLoadingConceptValues: false,
                ErrorOnLoadingConceptValues: undefined
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_GETALL_FAILURE':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isLoadingConceptValues: false,
                loadingConceptValuesSuccess: false,
                failOnLoadingConceptValues: true,
                ErrorOnLoadingConceptValues: action.error
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_CREATE_REQUEST':
        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_UPDATE_REQUEST':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isSavingConceptValue: true,
                conceptValueSaved: undefined,
                failOnSavingConceptValue: false,
                ErrorOnSavingConceptValue: undefined
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_CREATE_SUCCESS':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                conceptValues: [...(cons.conceptValues || []), action.conceptValue],
                isSavingConceptValue: false,
                conceptValueSaved: true,
                failOnSavingConceptValue: false,
                ErrorOnSavingConceptValue: undefined
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_UPDATE_SUCCESS':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                // Se reemplaza en el lugar: el orden de la grilla no tiene que
                // moverse porque se edito una fila.
                conceptValues: (cons.conceptValues || []).map((value: ProtocolConsumptionConceptValues) =>
                    value.id === action.conceptValueId ? { ...value, ...action.conceptValue, id: action.conceptValueId } : value
                ),
                isSavingConceptValue: false,
                conceptValueSaved: true,
                failOnSavingConceptValue: false,
                ErrorOnSavingConceptValue: undefined
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_CREATE_FAILURE':
        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_UPDATE_FAILURE':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isSavingConceptValue: false,
                conceptValueSaved: false,
                failOnSavingConceptValue: true,
                ErrorOnSavingConceptValue: action.error
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_DELETE_REQUEST':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                conceptValues: (cons.conceptValues || []).map((value: ProtocolConsumptionConceptValues) =>
                    value.id === action.conceptValueId
                        ? { ...value, isDeleting: true, isDeletedSuccessfully: undefined, failOnDeleting: false, ErrorOnDeleting: undefined }
                        : value
                )
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_DELETE_SUCCESS':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                conceptValues: (cons.conceptValues || []).filter(
                    (value: ProtocolConsumptionConceptValues) => value.id !== action.conceptValueId
                )
            }));

        case 'PROTOCOLCONSUMPTIONCONCEPTVALUE_DELETE_FAILURE':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                conceptValues: (cons.conceptValues || []).map((value: ProtocolConsumptionConceptValues) =>
                    value.id === action.conceptValueId
                        ? { ...value, isDeleting: false, isDeletedSuccessfully: false, failOnDeleting: true, ErrorOnDeleting: action.error }
                        : value
                )
            }));

        // ─── Discontinuación temprana y agrupación ───────────────────────────
        // El estado resultante lo trae el consumo devuelto por el servidor
        // (`condition` y `groupingId`); acá sólo se refleja el progreso.

        case 'PROTOCOLCONSUMPTION_SET_EARLYDISCONTINUATION_REQUEST':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isChangingEarlyDiscontinuation: true,
                earlyDiscontinuationChanged: undefined,
                failOnEarlyDiscontinuationChange: false,
                ErrorOnEarlyDiscontinuationChange: undefined
            }));

        case 'PROTOCOLCONSUMPTION_SET_EARLYDISCONTINUATION_SUCCESS':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                ...action.consumption,
                // El ViewModel no devuelve las colecciones del consumo: si se
                // pisaran con undefined, el detalle perdería lo ya cargado.
                conceptValues: action.consumption.conceptValues ?? cons.conceptValues ?? [],
                childConsumption: action.consumption.childConsumption ?? cons.childConsumption ?? [],
                billedIn: action.consumption.billedIn ?? cons.billedIn ?? [],
                isChangingEarlyDiscontinuation: false,
                earlyDiscontinuationChanged: true,
                failOnEarlyDiscontinuationChange: false,
                ErrorOnEarlyDiscontinuationChange: undefined
            }));

        case 'PROTOCOLCONSUMPTION_SET_EARLYDISCONTINUATION_FAILURE':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isChangingEarlyDiscontinuation: false,
                earlyDiscontinuationChanged: false,
                failOnEarlyDiscontinuationChange: true,
                ErrorOnEarlyDiscontinuationChange: action.error
            }));

        case 'PROTOCOLCONSUMPTION_SET_GROUPING_REQUEST':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isChangingGrouping: true,
                groupingChanged: undefined,
                failOnGroupingChange: false,
                ErrorOnGroupingChange: undefined
            }));

        case 'PROTOCOLCONSUMPTION_SET_GROUPING_SUCCESS':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                ...action.consumption,
                conceptValues: action.consumption.conceptValues ?? cons.conceptValues ?? [],
                childConsumption: action.consumption.childConsumption ?? cons.childConsumption ?? [],
                billedIn: action.consumption.billedIn ?? cons.billedIn ?? [],
                // Agrupar y desagrupar cambian estos dos, así que se toman tal
                // cual vienen: un `?? cons.x` dejaría pegado el valor anterior.
                groupingId: action.consumption.groupingId,
                parentGroupingId: action.consumption.parentGroupingId,
                isChangingGrouping: false,
                groupingChanged: true,
                failOnGroupingChange: false,
                ErrorOnGroupingChange: undefined
            }));

        case 'PROTOCOLCONSUMPTION_SET_GROUPING_FAILURE':
            return WriteConsumption(state, action.protocolId, action.consumptionId, (cons) => ({
                ...cons,
                isChangingGrouping: false,
                groupingChanged: false,
                failOnGroupingChange: true,
                ErrorOnGroupingChange: action.error
            }));

        case 'PROTOCOLCONSUMPTION_GET_BYID_REQUEST':
            return {
                ...state,
                isLoadingOneConsumption: true,
                LoadingOneConsumptionSuccess: false,
                FailGettingOneConsumption: false,
                ErrorGettingOneConsumption: undefined
            }
        
        case 'PROTOCOLCONSUMPTION_GET_BYID_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {
                const prevByIdConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption.id);
                const mergedByIdConsumption: ProtocolConsumption = {
                    ...action.consumption,
                    childConsumption: action.consumption.childConsumption ?? prevByIdConsumption?.childConsumption ?? [],
                    billedIn: action.consumption.billedIn ?? prevByIdConsumption?.billedIn ?? [],
                    conceptValues: action.consumption.conceptValues ?? prevByIdConsumption?.conceptValues ?? [],
                    groupingId: action.consumption.groupingId ?? prevByIdConsumption?.groupingId,
                    parentGroupingId: action.consumption.parentGroupingId ?? prevByIdConsumption?.parentGroupingId,
                };
                CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), mergedByIdConsumption]};
            }

            return {
                ...state,
                isLoadingOneConsumption: false,
                LoadingOneConsumptionSuccess: true,
                FailGettingOneConsumption: false,
                ErrorGettingOneConsumption: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GET_BYID_FAILURE':
            return {
                ...state,
                isLoadingOneConsumption: false,
                LoadingOneConsumptionSuccess: false,
                FailGettingOneConsumption: true,
                ErrorGettingOneConsumption: action.error
            };

        
        case 'PROTOCOLCONSUMPTION_CREATE_REQUEST':
            return {
                ...state,
                isCreatingConsumption: true,
                CreatingConsumptionSuccess: false,
                FailCreatingConsumption: false,
                ErrorCreatingConsumption: undefined
            };
        case 'PROTOCOLCONSUMPTION_CREATE_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []), action.consumption]};
            }

            return {
                ...state,
                isCreatingConsumption: false,
                CreatingConsumptionSuccess: true,
                FailCreatingConsumption: false,
                ErrorCreatingConsumption: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };
        
        case 'PROTOCOLCONSUMPTION_CREATE_FAILURE':
            return {
                ...state,
                isCreatingConsumption: false,
                CreatingConsumptionSuccess: false,
                FailCreatingConsumption: true,
                ErrorCreatingConsumption: action.error
            };
        
        case 'PROTOCOLCONSUMPTION_UPDATE_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumption.id);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumption.id), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };
        
        case 'PROTOCOLCONSUMPTION_UPDATE_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {

                const prevUpdateConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption.id);
                var CurrentConsumptionUpdated = action.consumption;

                if(CurrentConsumptionUpdated) {
                    
                    CurrentConsumptionUpdated = {
                        ...CurrentConsumptionUpdated,
                        childConsumption: CurrentConsumptionUpdated.childConsumption ?? prevUpdateConsumption?.childConsumption ?? [],
                        billedIn: CurrentConsumptionUpdated.billedIn ?? prevUpdateConsumption?.billedIn ?? [],
                        groupingId: CurrentConsumptionUpdated.groupingId ?? prevUpdateConsumption?.groupingId,
                        parentGroupingId: CurrentConsumptionUpdated.parentGroupingId ?? prevUpdateConsumption?.parentGroupingId,
                        isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined
                    };

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated.id), CurrentConsumptionUpdated]};

                    // Update consumptionsByPatient searching across all patient keys
                    if (CurrentProtocol.consumptionsByPatient) {
                        const updatedByPatient: { [key: string]: ProtocolConsumption[] } = {};
                        let found = false;
                        for (const key of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                            const list = CurrentProtocol.consumptionsByPatient[key];
                            if (list.some((c: ProtocolConsumption) => c.id === CurrentConsumptionUpdated.id)) {
                                updatedByPatient[key] = list.map((c: ProtocolConsumption) =>
                                    c.id === CurrentConsumptionUpdated.id ? CurrentConsumptionUpdated : c
                                );
                                found = true;
                            } else {
                                updatedByPatient[key] = list;
                            }
                        }
                        if (found) {
                            CurrentProtocol = { ...CurrentProtocol, consumptionsByPatient: updatedByPatient };
                        }
                    }
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_UPDATE_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };
        
        case 'PROTOCOLCONSUMPTION_DELETE_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isDeleting: true, isDeletedSuccessfully: false, failOnDeleting: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_DELETE_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionDeleted = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumptionDeleted) {
                    
                    CurrentConsumptionDeleted = {...CurrentConsumptionDeleted, isDeleting: false, isDeletedSuccessfully: true, failOnDeleting: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId)]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_DELETE_FAILURE':
                
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionDeletedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumptionDeletedFailure) {
                    
                    CurrentConsumptionDeletedFailure = {...CurrentConsumptionDeletedFailure, isDeleting: false, isDeletedSuccessfully: false, failOnDeleting: true, error: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionDeletedFailure]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_STATUS_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, ischangingStatus: true, statusChanged: false, failonStatusChange: false, ErrorOnStatusChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }

                // Also mark ischangingStatus in consumptionsByPatient
                if (CurrentProtocol && CurrentProtocol.consumptionsByPatient) {
                    const updatedByPatient: { [key: string]: ProtocolConsumption[] } = {};
                    for (const pKey of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                        const list = CurrentProtocol.consumptionsByPatient[pKey];
                        if (list?.some((c: ProtocolConsumption) => c.id === action.consumptionId)) {
                            updatedByPatient[pKey] = list.map((c: ProtocolConsumption) =>
                                c.id === action.consumptionId ? { ...c, ischangingStatus: true, statusChanged: false, failonStatusChange: false } : c
                            );
                        } else {
                            updatedByPatient[pKey] = list;
                        }
                    }
                    CurrentProtocol = { ...CurrentProtocol, consumptionsByPatient: updatedByPatient };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };
        case 'PROTOCOLCONSUMPTION_CHANGE_STATUS_SUCCESS':
            	
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumptionUpdated: ProtocolConsumption | undefined = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                // If not found in consumptions, search in consumptionsByPatient
                if (!CurrentConsumptionUpdated && CurrentProtocol.consumptionsByPatient) {
                    for (const key of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                        const found = CurrentProtocol.consumptionsByPatient[key]?.find((c: ProtocolConsumption) => c.id === action.consumptionId);
                        if (found) { CurrentConsumptionUpdated = found; break; }
                    }
                }

                // udpate consumption status on protocol consumptions
                if(CurrentConsumptionUpdated) {

                    if(action.isForAll) {
                        CurrentProtocol = {...CurrentProtocol, consumptions: CurrentProtocol.consumptions?.map((item: ProtocolConsumption) => {
                            if(item.serviceName === CurrentConsumptionUpdated?.serviceName) {
                                return {...item, status: action.status};
                            } else {
                                return item;
                            }
                        })};
                    } else {
                        CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, status: action.status};
                        CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated?.id), CurrentConsumptionUpdated]};
                    }
                    
                    CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, ischangingStatus: false, statusChanged: true, failonStatusChange: false, ErrorOnStatusChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated?.id), CurrentConsumptionUpdated]};

                    CurrentProtocol = {...CurrentProtocol, consumptionsToSettle: CurrentConsumptionUpdated.status === 6 ? [...(CurrentProtocol.consumptionsToSettle || []), CurrentConsumptionUpdated] : (CurrentProtocol.consumptionsToSettle || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated?.id)};

                    // Update consumptionsByPatient across all patient keys
                    if (CurrentProtocol.consumptionsByPatient) {
                        const updatedByPatient: { [key: string]: ProtocolConsumption[] } = {};
                        const serviceName = CurrentConsumptionUpdated?.serviceName;
                        for (const pKey of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                            const list = CurrentProtocol.consumptionsByPatient[pKey];
                            if (!list) { updatedByPatient[pKey] = list; continue; }
                            if (action.isForAll) {
                                updatedByPatient[pKey] = list.map((c: ProtocolConsumption) =>
                                    c.serviceName === serviceName ? { ...c, status: action.status, ischangingStatus: false, statusChanged: true, failonStatusChange: false } : c
                                );
                            } else if (list.some((c: ProtocolConsumption) => c.id === action.consumptionId)) {
                                updatedByPatient[pKey] = list.map((c: ProtocolConsumption) =>
                                    c.id === action.consumptionId ? { ...c, status: action.status, ischangingStatus: false, statusChanged: true, failonStatusChange: false } : c
                                );
                            } else {
                                updatedByPatient[pKey] = list;
                            }
                        }
                        CurrentProtocol = { ...CurrentProtocol, consumptionsByPatient: updatedByPatient };
                    }
                }

                // udpate consumption status on protocol visit consumptions
                if (CurrentProtocol.ConsumptionVisits?.length) {
                    CurrentProtocol = {
                        ...CurrentProtocol,
                        ConsumptionVisits: CurrentProtocol.ConsumptionVisits.map((visit: ProtocolConsumptionVisit) => {
                            if (!visit.consumptions?.some((item: ProtocolConsumption) => item.id === action.consumptionId)) {
                                return visit;
                            }
                            return {
                                ...visit,
                                consumptions: visit.consumptions.map((item: ProtocolConsumption) =>
                                    item.id === action.consumptionId
                                        ? { ...item, status: action.status }
                                        : item
                                ),
                            };
                        }),
                    };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_STATUS_FAILURE':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumptionUpdatedFailure) {
                    
                    CurrentConsumptionUpdatedFailure = {...CurrentConsumptionUpdatedFailure, ischangingStatus: false, statusChanged: false, failonStatusChange: true, ErrorOnStatusChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionUpdatedFailure]};
                }

                // Also update consumptionsByPatient on failure
                if (CurrentProtocol && CurrentProtocol.consumptionsByPatient) {
                    const updatedByPatient: { [key: string]: ProtocolConsumption[] } = {};
                    for (const pKey of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                        const list = CurrentProtocol.consumptionsByPatient[pKey];
                        if (list?.some((c: ProtocolConsumption) => c.id === action.consumptionId)) {
                            updatedByPatient[pKey] = list.map((c: ProtocolConsumption) =>
                                c.id === action.consumptionId ? { ...c, ischangingStatus: false, statusChanged: false, failonStatusChange: true } : c
                            );
                        } else {
                            updatedByPatient[pKey] = list;
                        }
                    }
                    CurrentProtocol = { ...CurrentProtocol, consumptionsByPatient: updatedByPatient };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'MARK_CONSUMPTION_FOLLOWUP_REQUEST':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            const followUpConsumptionId = action.consumptionId;

            if (CurrentProtocol) {
                let currentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === followUpConsumptionId);

                if (currentConsumption) {
                    currentConsumption = {
                        ...currentConsumption,
                        isMarkingFollowUp: true,
                        MarkingFollowUpSuccess: false,
                        FailMarkingFollowUp: false,
                        ErrorMarkingFollowUp: undefined
                    };

                    CurrentProtocol = {
                        ...CurrentProtocol,
                        consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== followUpConsumptionId), currentConsumption]
                    };
                }

                if (CurrentProtocol && CurrentProtocol.consumptionsByPatient) {
                    const updatedByPatient: { [key: string]: ProtocolConsumption[] } = {};
                    for (const pKey of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                        const list = CurrentProtocol.consumptionsByPatient[pKey];
                        if (list?.some((c: ProtocolConsumption) => c.id === followUpConsumptionId)) {
                            updatedByPatient[pKey] = list.map((c: ProtocolConsumption) =>
                                c.id === followUpConsumptionId
                                    ? { ...c, isMarkingFollowUp: true, MarkingFollowUpSuccess: false, FailMarkingFollowUp: false, ErrorMarkingFollowUp: undefined }
                                    : c
                            );
                        } else {
                            updatedByPatient[pKey] = list;
                        }
                    }
                    CurrentProtocol = { ...CurrentProtocol, consumptionsByPatient: updatedByPatient };
                }
            }

            return {
                ...state,
                isMarkingFollowUp: true,
                MarkingFollowUpSuccess: false,
                FailMarkingFollowUp: false,
                ErrorMarkingFollowUp: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'MARK_CONSUMPTION_FOLLOWUP_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            const followUpSuccessConsumptionId = action.consumptionId;

            if (CurrentProtocol) {
                let currentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === followUpSuccessConsumptionId);

                if (currentConsumption) {
                    currentConsumption = {
                        ...currentConsumption,
                        ...action.consumption,
                        markedAsFollowUp: action.consumption.markedAsFollowUp,
                        followUpDate: action.consumption.followUpDate,
                        isMarkingFollowUp: false,
                        MarkingFollowUpSuccess: true,
                        FailMarkingFollowUp: false,
                        ErrorMarkingFollowUp: undefined
                    };

                    CurrentProtocol = {
                        ...CurrentProtocol,
                        consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== followUpSuccessConsumptionId), currentConsumption]
                    };
                }

                if (CurrentProtocol && CurrentProtocol.consumptionsByPatient) {
                    const updatedByPatient: { [key: string]: ProtocolConsumption[] } = {};
                    for (const pKey of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                        const list = CurrentProtocol.consumptionsByPatient[pKey];
                        if (list?.some((c: ProtocolConsumption) => c.id === followUpSuccessConsumptionId)) {
                            updatedByPatient[pKey] = list.map((c: ProtocolConsumption) =>
                                c.id === followUpSuccessConsumptionId
                                    ? {
                                        ...c,
                                        ...action.consumption,
                                        markedAsFollowUp: action.consumption.markedAsFollowUp,
                                        followUpDate: action.consumption.followUpDate,
                                        isMarkingFollowUp: false,
                                        MarkingFollowUpSuccess: true,
                                        FailMarkingFollowUp: false,
                                        ErrorMarkingFollowUp: undefined
                                    }
                                    : c
                            );
                        } else {
                            updatedByPatient[pKey] = list;
                        }
                    }
                    CurrentProtocol = { ...CurrentProtocol, consumptionsByPatient: updatedByPatient };
                }
            }

            return {
                ...state,
                isMarkingFollowUp: false,
                MarkingFollowUpSuccess: true,
                FailMarkingFollowUp: false,
                ErrorMarkingFollowUp: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'MARK_CONSUMPTION_FOLLOWUP_FAIL':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            const followUpFailConsumptionId = action.consumptionId;

            if (CurrentProtocol) {
                let currentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === followUpFailConsumptionId);

                if (currentConsumption) {
                    currentConsumption = {
                        ...currentConsumption,
                        isMarkingFollowUp: false,
                        MarkingFollowUpSuccess: false,
                        FailMarkingFollowUp: true,
                        ErrorMarkingFollowUp: action.error
                    };

                    CurrentProtocol = {
                        ...CurrentProtocol,
                        consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== followUpFailConsumptionId), currentConsumption]
                    };
                }

                if (CurrentProtocol && CurrentProtocol.consumptionsByPatient) {
                    const updatedByPatient: { [key: string]: ProtocolConsumption[] } = {};
                    for (const pKey of Object.keys(CurrentProtocol.consumptionsByPatient)) {
                        const list = CurrentProtocol.consumptionsByPatient[pKey];
                        if (list?.some((c: ProtocolConsumption) => c.id === followUpFailConsumptionId)) {
                            updatedByPatient[pKey] = list.map((c: ProtocolConsumption) =>
                                c.id === followUpFailConsumptionId
                                    ? { ...c, isMarkingFollowUp: false, MarkingFollowUpSuccess: false, FailMarkingFollowUp: true, ErrorMarkingFollowUp: action.error }
                                    : c
                            );
                        } else {
                            updatedByPatient[pKey] = list;
                        }
                    }
                    CurrentProtocol = { ...CurrentProtocol, consumptionsByPatient: updatedByPatient };
                }
            }

            return {
                ...state,
                isMarkingFollowUp: false,
                MarkingFollowUpSuccess: false,
                FailMarkingFollowUp: true,
                ErrorMarkingFollowUp: action.error,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        // protocol consumption sync process actions

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETALL_BYPROTOCOLID_REQUEST':

            return {
                ...state,
                isLoadingAllSyncProcess: true,
                LoadingAllSyncProcessSuccess: false,
                FailGettingAllSyncProcess: false,
                ErrorGettingAllSyncProcess: undefined
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETALL_BYPROTOCOLID_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: action.processes};
            }

            return {
                ...state,
                isLoadingAllSyncProcess: false,
                LoadingAllSyncProcessSuccess: true,
                FailGettingAllSyncProcess: false,
                ErrorGettingAllSyncProcess: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };
        
        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETALL_BYPROTOCOLID_FAILURE':
            
            return {
                ...state,
                isLoadingAllSyncProcess: false,
                LoadingAllSyncProcessSuccess: false,
                FailGettingAllSyncProcess: true,
                ErrorGettingAllSyncProcess: action.error
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GET_BYID_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentProcess = CurrentProtocol.consumptionsSyncProcess?.find((item: any) => item.id === action.syncProcessId);

                if(CurrentProcess) {
                    
                    CurrentProcess = {...CurrentProcess, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []).filter((item: any) => item.id !== action.syncProcessId), CurrentProcess]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GET_BYID_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.process.protocolId);

            if(CurrentProtocol) {

                var CurrentProcessUpdated = action.process;

                if(CurrentProcessUpdated) {
                    
                    CurrentProcessUpdated = {...CurrentProcessUpdated, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []).filter((item: any) => item.id !== CurrentProcessUpdated.id), CurrentProcessUpdated]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.process.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GET_BYID_FAILURE':
        
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentProcessUpdatedFailure = CurrentProtocol.consumptionsSyncProcess?.find((item: any) => item.id === action.syncProcessId);

                if(CurrentProcess) {
                    
                    CurrentProcess = {...CurrentProcess, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []).filter((item: any) => item.id !== action.syncProcessId), CurrentProcess]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLOGS_BYID_REQUEST':

            return {
                ...state,
                isLoadingSyncProcessLogs: true,
                LoadingSyncProcessLogsSuccess: false,
                FailGettingSyncProcessLogs: false,
                ErrorGettingSyncProcessLogs: undefined,
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLOGS_BYID_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                const orderedLogs = [...(action.logs || [])].sort((a: ProtocolConsumptionSyncProcessLog, b: ProtocolConsumptionSyncProcessLog) => {
                    return new Date(b.created as any).getTime() - new Date(a.created as any).getTime();
                });

                CurrentProtocol = {
                    ...CurrentProtocol,
                    // Se guarda sólo la página recibida: el listado es paginado en
                    // el servidor y acumular páginas daría totales que no cierran.
                    consumptionsSyncProcessLogsByProcessId: {
                        ...(CurrentProtocol.consumptionsSyncProcessLogsByProcessId || {}),
                        [action.syncProcessId]: orderedLogs,
                    },
                    consumptionsSyncProcessLogsPaginationByProcessId: {
                        ...(CurrentProtocol.consumptionsSyncProcessLogsPaginationByProcessId || {}),
                        [action.syncProcessId]: action.paginationState,
                    },
                };
            }

            return {
                ...state,
                isLoadingSyncProcessLogs: false,
                LoadingSyncProcessLogsSuccess: true,
                FailGettingSyncProcessLogs: false,
                ErrorGettingSyncProcessLogs: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLOGS_BYID_FAILURE':

            return {
                ...state,
                isLoadingSyncProcessLogs: false,
                LoadingSyncProcessLogsSuccess: false,
                FailGettingSyncProcessLogs: true,
                ErrorGettingSyncProcessLogs: action.error,
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLAST_BYPROTOCOLID_REQUEST':
            
            return {
                ...state,
                isLoadingLastSyncProcess: true,
                LoadingLastSyncProcessSuccess: false,
                FailGettingLastSyncProcess: false,
                ErrorGettingLastSyncProcess: undefined
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLAST_BYPROTOCOLID_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, lastConsumptionSyncProcess: action.process};
            }

            return {
                ...state,
                isLoadingLastSyncProcess: false,
                LoadingLastSyncProcessSuccess: true,
                FailGettingLastSyncProcess: false,
                ErrorGettingLastSyncProcess: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLAST_BYPROTOCOLID_FAILURE':
            
            return {
                ...state,
                isLoadingLastSyncProcess: false,
                LoadingLastSyncProcessSuccess: false,
                FailGettingLastSyncProcess: true,
                ErrorGettingLastSyncProcess: action.error
            };  
            
        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_CREATE_REQUEST':
            
            return {
                ...state,
                isCreatingSyncProcess: true,
                CreatingSyncProcessSuccess: false,
                FailCreatingSyncProcess: false,
                ErrorCreatingSyncProcess: undefined
            };
            
        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_CREATE_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.process.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []), action.process], lastConsumptionSyncProcess: action.process};
            }

            return {
                ...state,
                isCreatingSyncProcess: false,
                CreatingSyncProcessSuccess: true,
                FailCreatingSyncProcess: false,
                ErrorCreatingSyncProcess: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.process.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_CREATE_FAILURE':
            
            return {
                ...state,
                isCreatingSyncProcess: false,
                CreatingSyncProcessSuccess: false,
                FailCreatingSyncProcess: true,
                ErrorCreatingSyncProcess: action.error
            };
        // protocol consumption totals

        case 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_REQUEST':
            return {
                ...state,
                isLoadingTotals: true,
                LoadingTotalsSuccess: false,	
                FailGettingTotals: false,
                ErrorGettingTotals: undefined
            };
        
        case 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_SUCCESS':


            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, AmountTotals: [...(CurrentProtocol.AmountTotals || []).filter((total: ProtocolConsumptionTotal) =>  total.status != action.status), ...action.total]};
            }

            return {
                ...state,
                isLoadingTotals: false,
                LoadingTotalsSuccess: true,
                FailGettingTotals: false,
                ErrorGettingTotals: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE':
            return {
                ...state,
                isLoadingTotals: false,
                LoadingTotalsSuccess: false,
                FailGettingTotals: true,
                ErrorGettingTotals: action.error
            };

        // protocol consumption change concept actions

        case 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isConcepAssociationChanging: true, conceptAssociationChanged: false, failonConceptAssociationChange: false, ErrorOnConceptAssociationChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumptionUpdated = CurrentProtocol.consumptions?.find((consumption: ProtocolConsumption) => consumption.id === action.consumptionId);

                if(CurrentConsumptionUpdated) {
                    
                    CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, isConcepAssociationChanging: false, conceptAssociationChanged: true, failonConceptAssociationChange: false, ErrorOnConceptAssociationChange: undefined};

                    const updatedConsumptionIds = action.updatedConsumptions.map((item: ProtocolConsumption) => { return item.id } ) ?? [];

                    console.log("total: ", updatedConsumptionIds.length);

                    console.log("ids: ", updatedConsumptionIds);

                    const actuallConsumptions: ProtocolConsumption[] = CurrentProtocol?.consumptions ?? [];

                    console.log("total: ", actuallConsumptions.length);

                    console.log("consumptions: ", actuallConsumptions);

                    const filtredConsumptions: ProtocolConsumption[] = actuallConsumptions.filter((item: ProtocolConsumption) => !updatedConsumptionIds.includes(item.id));

                    console.log("total: ", filtredConsumptions.length);

                    console.log("consumptions: ", filtredConsumptions);

                    // Preserve childConsumption/groupingId not returned by the concept-change API
                    const mergedUpdatedConsumptions: ProtocolConsumption[] = action.updatedConsumptions.map((updated: ProtocolConsumption) => {
                        const existing = actuallConsumptions.find((c: ProtocolConsumption) => c.id === updated.id);
                        return {
                            ...updated,
                            childConsumption: updated.childConsumption ?? existing?.childConsumption ?? [],
                            billedIn: updated.billedIn ?? existing?.billedIn ?? [],
                            groupingId: updated.groupingId ?? existing?.groupingId,
                            parentGroupingId: updated.parentGroupingId ?? existing?.parentGroupingId,
                        };
                    });

                    const updatedConsumptions: ProtocolConsumption[] = [...filtredConsumptions, ...mergedUpdatedConsumptions]

                    console.log("total: ", updatedConsumptions.length);

                    console.log("consumptions: ", updatedConsumptions);

                    CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isConcepAssociationChanging: false, conceptAssociationChanged: false, failonConceptAssociationChange: true, ErrorOnConceptAssociationChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        // protocol consumption change producer actions

        case 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isProducerChanging: true, producerChanged: false, failonProducerChange: false, ErrorOnProducerChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumptionUpdated = CurrentProtocol.consumptions?.find((consumption: ProtocolConsumption) => consumption.id === action.consumptionId);

                if(CurrentConsumptionUpdated) {
                    
                    CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, isProducerChanging: false, producerChanged: true, failonProducerChange: false, ErrorOnProducerChange: undefined, producer: action.producerId};

                    const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionUpdated];

                    CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumptionUpdatedFailure) {

                    CurrentConsumptionUpdatedFailure = {...CurrentConsumptionUpdatedFailure, isProducerChanging: false, producerChanged: false, failonProducerChange: true, ErrorOnProducerChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumptionUpdatedFailure]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        // protocol consumption change provider actions

        case 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_REQUEST':
            
            var CurrentProtocolProviderRequest = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocolProviderRequest) {

                var CurrentConsumption = CurrentProtocolProviderRequest.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isProviderChanging: true, providerChanged: false, failonProviderChange: false, ErrorOnProviderChange: undefined};

                    CurrentProtocolProviderRequest = {...CurrentProtocolProviderRequest, consumptions: [...(CurrentProtocolProviderRequest.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocolProviderRequest ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocolProviderRequest] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_SUCCESS':
            
            var CurrentProtocolProviderSuccess = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocolProviderSuccess) {

                const prevProviderConsumption = CurrentProtocolProviderSuccess.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption?.id);
                const mergedProviderConsumption: ProtocolConsumption = {
                    ...action.consumption,
                    childConsumption: action.consumption.childConsumption ?? prevProviderConsumption?.childConsumption ?? [],
                    billedIn: action.consumption.billedIn ?? prevProviderConsumption?.billedIn ?? [],
                    groupingId: action.consumption.groupingId ?? prevProviderConsumption?.groupingId,
                    parentGroupingId: action.consumption.parentGroupingId ?? prevProviderConsumption?.parentGroupingId,
                };
                const updatedConsumptions = [...(CurrentProtocolProviderSuccess.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption?.id), mergedProviderConsumption];

                CurrentProtocolProviderSuccess = {...CurrentProtocolProviderSuccess, consumptions: updatedConsumptions};
            }

            return {
                ...state,
                list: (CurrentProtocolProviderSuccess ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocolProviderSuccess] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_FAILURE':
            
            var CurrentProtocolProviderFail = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocolProviderFail) {

                var CurrentConsumption = CurrentProtocolProviderFail.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isProviderChanging: false, providerChanged: false, failonProviderChange: true, ErrorOnProviderChange: action.error};
                    
                    console.log("CurrentConsumption: ", CurrentConsumption );
                    
                    let CurrentProtocolConsumption: ProtocolConsumption[] = CurrentProtocolProviderFail.consumptions?.filter((item: ProtocolConsumption) => item.id !== action.consumptionId) || [];

                    CurrentProtocolProviderFail = {...CurrentProtocolProviderFail, consumptions: [...CurrentProtocolConsumption, CurrentConsumption]};
                }

                console.log("CurrentProtocolProviderFail: ", CurrentProtocolProviderFail);
            }

            return {
                ...state,
                list: (CurrentProtocolProviderFail ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocolProviderFail] : state.list)
            };

        // protocol consumption change medical service actions

        case 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isMedicalServiceChanging: true, medicalServiceChanged: false, failonMedicalServiceChange: false, ErrorOnMedicalServiceChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), action.consumption];

                CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isMedicalServiceChanging: false, medicalServiceChanged: false, failonMedicalServiceChange: true, ErrorOnMedicalServiceChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_TYPE_REQUEST':
                
                CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
    
                if(CurrentProtocol) {
    
                    var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);
    
                    if(CurrentConsumption) {
                        
                        CurrentConsumption = {...CurrentConsumption, isVisitTypeChanging: true, visitTypeChanged: false, failonVisitTypeChange: false, ErrorOnVisitTypeChange: undefined};
    
                        CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                    }
                }
    
                return {
                    ...state,
                    list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
                };
        
        case 'PROTOCOLCONSUMPTION_CHANGE_TYPE_SUCCESS':

                    
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption.id);

                if(CurrentConsumption) {
                    
                    const mergedTypeConsumption: ProtocolConsumption = {
                        ...action.consumption,
                        childConsumption: action.consumption.childConsumption ?? CurrentConsumption.childConsumption ?? [],
                        billedIn: action.consumption.billedIn ?? CurrentConsumption.billedIn ?? [],
                        groupingId: action.consumption.groupingId ?? CurrentConsumption.groupingId,
                        parentGroupingId: action.consumption.parentGroupingId ?? CurrentConsumption.parentGroupingId,
                        isVisitTypeChanging: false,
                        visitTypeChanged: true,
                        failonVisitTypeChange: false,
                        ErrorOnVisitTypeChange: undefined,
                    };

                    const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), mergedTypeConsumption];

                    CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };
            

        case 'PROTOCOLCONSUMPTION_CHANGE_TYPE_FAILURE':
                                                                
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isVisitTypeChanging: false, visitTypeChanged: false, failonVisitTypeChange: true, ErrorOnVisitTypeChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };                                                      

        // set as procedure
        case 'PROTOCOLCONSUMPTION_SET_PROCEDURE_REQUEST':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumption) {
                    CurrentConsumption = { ...CurrentConsumption, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption] };
                }
            }

            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_PROCEDURE_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                const Updated = { ...action.consumption, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined } as ProtocolConsumption;
                CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions ?? []).filter((c: ProtocolConsumption) => c.id !== Updated.id), Updated] };
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_PROCEDURE_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                var CurrentConsumptionFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumptionFailure) {
                    CurrentConsumptionFailure = { ...CurrentConsumptionFailure, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((c: ProtocolConsumption) => c.id !== action.consumptionId), CurrentConsumptionFailure] };
                }
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        // set as additional
        case 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_REQUEST':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                var CurrentConsumptionAdd = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumptionAdd) {
                    CurrentConsumptionAdd = { ...CurrentConsumptionAdd, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionAdd] };
                }
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                const UpdatedAdd = { ...action.consumption, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined } as ProtocolConsumption;
                CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions ?? []).filter((c: ProtocolConsumption) => c.id !== UpdatedAdd.id), UpdatedAdd] };
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                var CurrentConsumptionAddFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumptionAddFailure) {
                    CurrentConsumptionAddFailure = { ...CurrentConsumptionAddFailure, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((c: ProtocolConsumption) => c.id !== action.consumptionId), CurrentConsumptionAddFailure] };
                }
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        // protocol consumption change visit (stage) actions

        case 'PROTOCOLCONSUMPTION_CHANGE_VISIT_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    // Use generic updating flags while stage change is in progress
                    CurrentConsumption = { ...CurrentConsumption, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption] };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_VISIT_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                // identify previous stage before replacing
                let PreviousConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption.id);
                const previousStageId = PreviousConsumption?.stageId;

                // updated consumption payload — preserve grouping/child data not returned by the API
                const UpdatedConsumption: ProtocolConsumption = {
                    ...action.consumption,
                    childConsumption: action.consumption.childConsumption ?? PreviousConsumption?.childConsumption ?? [],
                    billedIn: action.consumption.billedIn ?? PreviousConsumption?.billedIn ?? [],
                    groupingId: action.consumption.groupingId ?? PreviousConsumption?.groupingId,
                    parentGroupingId: action.consumption.parentGroupingId ?? PreviousConsumption?.parentGroupingId,
                    isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined
                } as ProtocolConsumption;

                // replace in flat list
                CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== UpdatedConsumption.id), UpdatedConsumption] };

                // reflect movement across visits if visits are loaded
                if (CurrentProtocol.ConsumptionVisits?.length) {
                    let UpdatedVisits = [...(CurrentProtocol.ConsumptionVisits ?? [])];

                    // remove from any visit that currently contains it and capture removal
                    UpdatedVisits = UpdatedVisits.map((visit: ProtocolConsumptionVisit) => {
                        if (!visit.consumptions?.some((c: ProtocolConsumption) => c.id === UpdatedConsumption.id)) {
                            return visit;
                        }
                        return { ...visit, consumptions: (visit.consumptions || []).filter((c: ProtocolConsumption) => c.id !== UpdatedConsumption.id) };
                    });

                    // add to new visit if present
                    UpdatedVisits = UpdatedVisits.map((visit: ProtocolConsumptionVisit) => {
                        const matchesTarget = visit.contractStageId === UpdatedConsumption.stageId && visit.patientNumberInProtocol === UpdatedConsumption.patientNumberInProtocol;
                        if (!matchesTarget) return visit;
                        return { ...visit, consumptions: [...(visit.consumptions || []).filter((c: ProtocolConsumption) => c.id !== UpdatedConsumption.id), UpdatedConsumption] };
                    });

                    CurrentProtocol = { ...CurrentProtocol, ConsumptionVisits: UpdatedVisits };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_VISIT_FAILURE':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    CurrentConsumption = { ...CurrentConsumption, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption] };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };


        case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_REQUEST_ACTION':
        
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId) || undefined;

            if(CurrentProtocol) {

                var CurrentStage = CurrentProtocol?.ContractVisits?.find((stage: ContractStage) => stage.id === action.contractStageId);

                if (CurrentStage) {   
                    
                    CurrentStage = {
                        ...CurrentStage,
                        isLinkingToAProtocolVisit: false,
                        linkedToAProtocolVisitSuccessfully: true, 
                        failOnLinkingToAProtocolVisit: false,
                        errorOnLinkingToAProtocolVisit: undefined
                    };

                    CurrentProtocol.ContractVisits = [...CurrentProtocol?.ContractVisits?.filter((stage: ContractStage) => stage.id !== CurrentStage?.id) ?? [], CurrentStage];
                }
            }
            
            return {
                ...state,
                list: CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== CurrentProtocol!.id) ?? [], CurrentProtocol] : state.list
            }
        
        case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentStage = CurrentProtocol?.ContractVisits?.find((stage: ContractStage) => stage.id === action.contractStageId);

                if (CurrentStage) {  
                    
                    CurrentStage = {
                        ...CurrentStage,
                        isLinkingToAProtocolVisit: false,
                        linkedToAProtocolVisitSuccessfully: true, 
                        failOnLinkingToAProtocolVisit: false,
                        errorOnLinkingToAProtocolVisit: undefined,
                        emrProtocolVisitIdRelated: action.protocolVisitId
                    };

                    CurrentProtocol.ContractVisits = [...CurrentProtocol?.ContractVisits?.filter((stage: ContractStage) => stage.id !== CurrentStage?.id) ?? [], CurrentStage];
                }
            }
            
            return {
                ...state,
                list: CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== CurrentProtocol!.id) ?? [], CurrentProtocol] : state.list
            }

        case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_FAIL_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentStage = CurrentProtocol?.ContractVisits?.find((stage: ContractStage) => stage.id === action.contractStageId);

                if (CurrentStage) {                    
                    
                    CurrentStage = {
                        ...CurrentStage,
                        isLinkingToAProtocolVisit: false,
                        linkedToAProtocolVisitSuccessfully: false, 
                        failOnLinkingToAProtocolVisit: true,
                        errorOnLinkingToAProtocolVisit: action.error
                    };

                    CurrentProtocol.ContractVisits = [...CurrentProtocol?.ContractVisits?.filter((stage: ContractStage) => stage.id !== CurrentStage?.id) ?? [], CurrentStage];
                }
            }

            return {
                ...state,
                list: CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== CurrentProtocol!.id) ?? [], CurrentProtocol] : state.list
            }

            // consumption change amount actions
                
        case 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                const CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    const UpdatedConsumption = {...CurrentConsumption, isAmountChanging: true, amountChanged: false, failonAmountChange: false, ErrorOnAmountChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), UpdatedConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                const CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption.id);

                const UpdatedConsumption: ProtocolConsumption = {
                    ...(CurrentConsumption ?? action.consumption),
                    ...action.consumption,
                    childConsumption: action.consumption.childConsumption ?? CurrentConsumption?.childConsumption ?? [],
                    billedIn: action.consumption.billedIn ?? CurrentConsumption?.billedIn ?? [],
                    groupingId: action.consumption.groupingId ?? CurrentConsumption?.groupingId,
                    parentGroupingId: action.consumption.parentGroupingId ?? CurrentConsumption?.parentGroupingId,
                    isAmountChanging: false,
                    amountChanged: true,
                    failonAmountChange: false,
                    ErrorOnAmountChange: undefined
                };

                const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), UpdatedConsumption];

                CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                const CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumptionUpdatedFailure) {

                    const UpdatedConsumption = {...CurrentConsumptionUpdatedFailure, isAmountChanging: false, amountChanged: false, failonAmountChange: true, ErrorOnAmountChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), UpdatedConsumption]};
                }

            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingConsumptionsToSettle: true, gettingConsumptionsToSettleSuccess: false, failOnGettingConsumptionsToSettle: false, ErrorOnGettingConsumptionsToSettle: undefined};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingConsumptionsToSettle: false, gettingConsumptionsToSettleSuccess: true, failOnGettingConsumptionsToSettle: false, ErrorOnGettingConsumptionsToSettle: undefined, consumptionsToSettle: action.consumptions};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
                
                if(CurrentProtocol) {
                    CurrentProtocol = {...CurrentProtocol, isGettingConsumptionsToSettle: false, gettingConsumptionsToSettleSuccess: false, failOnGettingConsumptionsToSettle: true, ErrorOnGettingConsumptionsToSettle: action.error};
                }

                return {
                    ...state,
                    list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
                };
        // PDF Export cases
        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_REQUEST_ACTION':
            return {
                ...state,
                isExportingPdf: true,
                ExportingPdfSuccess: false,
                FailExportingPdf: false,
                ErrorExportingPdf: undefined,
                pdfBlob: undefined
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_RECEIVE_ACTION':
            return {
                ...state,
                isExportingPdf: false,
                ExportingPdfSuccess: true,
                FailExportingPdf: false,
                ErrorExportingPdf: undefined,
                pdfBlob: action.pdfBlob
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_FAIL_ACTION':
            return {
                ...state,
                isExportingPdf: false,
                ExportingPdfSuccess: false,
                FailExportingPdf: true,
                ErrorExportingPdf: action.error,
                pdfBlob: undefined
            };

        // Excel Export cases
        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_REQUEST_ACTION':
            return {
                ...state,
                isExportingVisitToExcel: true,
                ExportingVisitToExcelSuccess: false,
                FailExportingVisitToExcel: false,
                ErrorExportingVisitToExcel: undefined,
                visitExcelBlob: undefined
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_RECEIVE_ACTION':
            return {
                ...state,
                isExportingVisitToExcel: false,
                ExportingVisitToExcelSuccess: true,
                FailExportingVisitToExcel: false,
                ErrorExportingVisitToExcel: undefined,
                visitExcelBlob: action.excelBlob
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_FAIL_ACTION':
            return {
                ...state,
                isExportingVisitToExcel: false,
                ExportingVisitToExcelSuccess: false,
                FailExportingVisitToExcel: true,
                ErrorExportingVisitToExcel: action.error,
                visitExcelBlob: undefined
            };
        default:
        return state;
    }
};